var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3298 29.8335V29.8329H29.3334V24.4539C29.3334 21.8225 28.7669 19.7954 25.6906 19.7954C24.2117 19.7954 23.2193 20.607 22.8141 21.3764H22.7713V20.0411H19.8545V29.8329H22.8917V24.9844C22.8917 23.7077 23.1337 22.4733 24.7147 22.4733C26.2724 22.4733 26.2956 23.9302 26.2956 25.0662V29.8335H29.3298Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9087 20.0415H17.9496V29.8333H14.9087V20.0415Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.428 15.1667C15.4557 15.1667 14.6667 15.9557 14.6667 16.928C14.6667 17.9002 15.4557 18.7057 16.428 18.7057C17.4002 18.7057 18.1892 17.9002 18.1892 16.928C18.1886 15.9557 17.3996 15.1667 16.428 15.1667V15.1667Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 43,
    height: 43,
    rx: 11.5,
    stroke: "#E2E4E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e1c7f5f4f47f207d725e5317e5f3d136.svg";
export { ForwardRef as ReactComponent };